import { Link } from "react-router-dom";
import { Car, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { PartnerBrb } from "@/components/PartnerBrb";
import { CONTACT } from "@/constants/contact";
import { IMAGES } from "@/constants/images";

const infos = [
  "Marque et modèle",
  "Année de mise en circulation",
  "Kilométrage",
  "Motorisation et boîte de vitesses",
  "Équipements",
  "Prix de vente",
  "État général et informations relatives à l'entretien",
];

export default function OccasionsPage() {
  return (
    <div data-testid="occasions-page">
      <PageHero
        image={IMAGES.occasions}
        imageAlt="Remise de clés d'un véhicule d'occasion"
        imageTestid="occasions-bg-image"
        eyebrow="Véhicules d'occasion"
        title="Trouvez votre prochain véhicule chez MECA AUTO CLEAN 01"
      >
        MECA AUTO CLEAN 01 vous propose une activité de vente de véhicules
        d'occasion. Pour connaître les véhicules actuellement disponibles,
        contactez directement le garage : chaque véhicule est présenté avec ses
        caractéristiques complètes.
      </PageHero>

      <section className="border-t border-border">
        <div className="mx-auto max-w-6xl px-4 py-20">
          <Reveal>
            <div className="rounded-lg border border-border bg-card p-6 sm:p-8">
              <div className="flex items-center gap-3">
                <Car className="h-6 w-6 text-primary" />
                <h2 className="font-display text-xl font-semibold uppercase">
                  Les informations essentielles pour faire votre choix
                </h2>
              </div>
              <ul className="mt-6 grid gap-3 text-sm sm:grid-cols-2">
                {infos.map((info) => (
                  <li key={info} className="flex items-start gap-2">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
                    {info}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-12 flex flex-wrap gap-3">
              <Button asChild size="lg" data-testid="occasions-whatsapp-button" className="bg-[#25d366] text-white hover:bg-[#1eb857]">
                <a href={CONTACT.whatsappLink} target="_blank" rel="noopener noreferrer">
                  <MessageCircle className="mr-2 h-4 w-4" /> Demander les véhicules disponibles
                </a>
              </Button>
              <Button asChild size="lg" variant="outline" data-testid="occasions-depot-vente-button">
                <Link to="/depot-vente">Vendre mon véhicule en dépôt-vente</Link>
              </Button>
            </div>
          </Reveal>
        </div>
      </section>

      <PartnerBrb />
    </div>
  );
}
